// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Mitr:wght@500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  margin: 0;
  padding: 0;
  height: 100vh;
  width: 100vw;

  background-color: #6e5c62;
}

div:focus-visible {
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/style/index.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,aAAa;EACb,YAAY;;EAEZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Mitr:wght@500&display=swap');\n\nhtml, body {\n  margin: 0;\n  padding: 0;\n  height: 100vh;\n  width: 100vw;\n\n  background-color: #6e5c62;\n}\n\ndiv:focus-visible {\n  outline: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
